import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { ActivatedRoute, Router } from '@angular/router';
import { MarketingApiService } from 'src/app/services/api/marketing-api.service';

@Component({
  selector: 'app-helping-detail-page',
  templateUrl: './helping-detail-page.component.html',
  styleUrls: ['./helping-detail-page.component.scss'],
})
export class HelpingDetailPageComponent implements OnInit {
  @ViewChild(MatPaginator, { static: true }) paginator!: MatPaginator;
  id: number;

  page = 0;
  pageSize = 5;
  total = 0;

  constructor(
    private api: MarketingApiService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.id = parseInt(this.route.snapshot.paramMap.get('tag') || '0');
    this.findArticleTags();
    this.findArticles(this.id);
  }

  ngOnInit(): void {
    this.paginator._intl.itemsPerPageLabel = '每页显示';
  }

  back() {
    this.router.navigate(['/helping']);
  }

  categories: any[] = [];

  cards: any[] = [];

  goto() {
    window.location.href = '/helping/detail/article';
  }

  loading = false;
  async findArticles(id: number) {
    try {
      this.loading = true;
      const r = await this.api.findArticlesTag(
        id,
        this.page + 1,
        this.pageSize
      );
      const data = r.data;
      this.cards = data.list;
      this.page = data.page - 1;
      this.pageSize = data.page_size;
      this.total = data.total;
    } catch (error) {
    } finally {
      this.loading = false;
    }
  }

  tags: any[] = [];
  loadingTag = false;
  async findArticleTags() {
    try {
      this.loadingTag = true;
      const r = await this.api.findArticleTags();
      this.categories = r.data;
    } catch (error) {
    } finally {
      this.loadingTag = false;
    }
  }

  gotoTag(id: number) {
    this.id = id;
    this.router.navigate(['/helping/detail', id]);
    this.findArticles(id);
  }

  onPageChange(e: any) {
    this.page = e.pageIndex;
    this.pageSize = e.pageSize;
    this.findArticles(this.id);
  }
}
